import type { ApolloClient } from "@apollo/client";
import {
  createStaleWorkspaceLink,
  getWorkspaceHeader,
  registerWorkspaceScopedClient,
} from "@ticketon/marketing/workspace";
import { createPlatformAdminClient } from "./platformAdminClient";

const MARKETING_ADMIN_GRAPHQL_URI = "/platform/admin/marketing/graphql";

let marketingAdminClient: ApolloClient | null = null;

/**
 * The marketing schema, used only for the workspace asset library the landing page editor
 * picks images from. Everything travel-specific stays on the travel client; this one exists
 * because assets live in the user's marketing workspace and the request has to carry its id.
 */
export function getMarketingAdminClient(): ApolloClient {
  if (!marketingAdminClient) {
    marketingAdminClient = createPlatformAdminClient(MARKETING_ADMIN_GRAPHQL_URI, {
      headers: getWorkspaceHeader,
      links: [createStaleWorkspaceLink()],
    });

    registerWorkspaceScopedClient(marketingAdminClient);
  }
  return marketingAdminClient;
}

export function resetMarketingAdminClient(): void {
  marketingAdminClient = null;
}
